module.exports = __webpack_public_path__ + "img/3.3e8b9aad.jpg";